import { Component, Input, OnInit } from '@angular/core';
import { CustoerPortalDoor } from '../../models/custoer-portal-door';
import { CustoerPortalInside } from '../../models/custoer-portal-inside';
import { Decor } from '../../models/decor';
import { Inside } from '../../models/inside';
import { LayoutType } from '../../models/layout-type';
import { DecorService } from '../../services/decor.service';
import { InsideService } from '../../services/inside.service';
import { FileUploadService } from '../../../../directives/file-drop/file-upload.service';
import { IFileInfo } from '../../../../directives/file-drop/interfaces/IFileInfo';

@Component({
  selector: 'app-customer-portal-layout-view',
  templateUrl: './customer-portal-layout-view.component.html',
  styleUrls: ['./customer-portal-layout-view.component.css']
})
export class CustomerPortalLayoutViewComponent implements OnInit {
  @Input() title: string;
  @Input() width: number;
  @Input() height: number;
  @Input() depth: number;
  @Input() noOfDoors: number;
  @Input() layoutType: LayoutType;
  @Input() doors: CustoerPortalDoor[];
  @Input() insides: CustoerPortalInside[];
  public insideMap:Map<string, Inside> = null;
  public decorMap:Map<string, Decor> = null;


  constructor(
    private insideService:InsideService,
    private decorService:DecorService,
    private fileUploadService:FileUploadService) { }

  ngOnInit() {
    if(this.insides){
      let idfilter = 'id in (';
      let i = 0;
      this.insides.forEach(inside => {
        if(i>0){
          idfilter += ',';          
        }
        idfilter += inside.insideId;          
        i++;
      });
      idfilter += ')';
      this.insideService.Filter(idfilter).subscribe(result => {
        if(result && result.payload){
          this.insideMap = new Map<string, Inside>();
          result.payload.forEach(inside => {
            this.insideMap.set(inside.id, inside);
          })
        }
      })
    }
    if(this.doors){
      let idfilter = 'id in (';
      let i = 0;
      this.doors.forEach(door => {
        if(door.panel1Container){
          if(i>0){
            idfilter += ',';                      
          }
          idfilter += door.panel1Container;
          i++;          
        }
        if(door.panel2Container){
          if(i>0){
            idfilter += ',';                      
          }
          idfilter += door.panel2Container;
          i++;          
        }
        if(door.panel3Container){
          if(i>0){
            idfilter += ',';                      
          }
          idfilter += door.panel3Container;
          i++;          
        }
        if(door.panel4Container){
          if(i>0){
            idfilter += ',';                      
          }
          idfilter += door.panel4Container;
          i++;          
        }
        if(door.panel5Container){
          if(i>0){
            idfilter += ',';                      
          }
          idfilter += door.panel5Container;
          i++;          
        }
      });
      idfilter += ')';
      this.decorService.Filter(idfilter).subscribe(result => {
        if(result && result.payload){
          this.decorMap = new Map<string, Decor>();
          result.payload.forEach(decor => {
            this.decorMap.set(decor.id, decor);
          })
        }
      })
    }
  }
  generateImageLink(insideId:string){
    let inside = this.insideMap.get(insideId);
    let ret = null;
    if(inside){
      ret = this.getLink(inside.id,inside.picture);
    }
    return ret;
  }
  getLink(container:string, id:string):string{
    // let fileInfo:IFileInfo = {
    //   container: container,
    //   id: id,
    //   variant: 'Thumbnail'
    // };
    //let url:string = this.fileUploadService.GetVariantLink(fileInfo);
    let fileInfo:IFileInfo = {
      container: container,
      id: id
    };

    let url:string = this.fileUploadService.GetLink(fileInfo);
    return url?url:null;
  }
}
